function update_rates_layout(element, value) {
  const formDiv = $("#" + element).parents(".container-fluid");
  const ratesDiv = formDiv.find("#rates-fields");
  const convertTypeTH = formDiv.find("#convert_type_th");

  if (value === "coin_tier") {
    convertTypeTH.html("<p><strong>Convert To</strong></p>");
    ratesDiv.show();
  } else if (value === "coin_base_rate") {
    ratesDiv.hide();
  } else if (value === "coin_base_rate_x_tier_multiplier") {
    convertTypeTH.html("<p><strong>Multiplier</strong></p>");
    ratesDiv.show();
  }
}

$(document).ready(function () {
  update_rates_layout(
    "converter_convert_type",
    $("#converter_convert_type").find(":selected").val()
  );

  $(document).on("change", "#converter_convert_type", function () {
    update_rates_layout(this.id, this.value);
  });
});
